import Vue from 'vue';
import Vuex from 'vuex';

import urlsAPI from '../../config/urlsAPI';
import handlerError from '../../utils/errors';
import { axiosInstance, busEvent } from '../../main';

Vue.use(Vuex);

export const ClientStoreModel = {
  name: '',
  phone: '',
  email: undefined,
  isActive: true,
  contractNr: undefined,
  contractValue: undefined,
  county: '',
  city: '',
  street: '',
  addressDetails: '',
  operation: '',
  deviceType: '',
  deviceFeatures: '',
  deviceRelease: '',
  deviceManufacter: '',
  deviceCheckReport: '',
  deviceLivret: '',
  livretType: undefined,
  devicePlace: '',
  observations: undefined,
  contract: undefined,
  cnp: undefined,
  // notes: undefined,
  revisionDate: '',
  checkDate: '',
  consumptionPlaceCodeAnre: '',
  technicalDocumentationNrAnre: '',
  technicalDocumentationYearAnre: '',
  checkDateAnre: undefined,
};

export default {
  namespaced: true,
  state: {
    clients: [],
    client: { ...ClientStoreModel },
    checks: [],
    revisions: [],
  },
  mutations: {
    updateClient(state, client) {
      state.client = client;
    },
    updateClients(state, clients) {
      state.clients = clients;
    },
    addClient(state, client) {
      state.clients.push(client);
    },
    putClient(state, client) {
      state.clients = state.clients.map((value) => (client.id === value.id ? client : value));
    },
    deleteAction(state, id) {
      state.clients = state.clients.filter((client) => client.id !== id);
    },
    updateChecks(state, checks) {
      state.checks = checks;
    },
    updateRevisions(state, revisions) {
      state.revisions = revisions;
    },
  },
  actions: {
    async getClient({ commit }, id) {
      axiosInstance
        .get(urlsAPI.clientsURL + id)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('updateClient', response.data);
          }
        })
        .catch(handlerError);
    },

    async getExcelClient(body, { start, end, isAthos }) {
      const url = isAthos ? urlsAPI.clientsAthosExportExcelURL : urlsAPI.clientsExportExcelURL;
      return axiosInstance
        .get(url, {
          params: {
            start,
            end,
          },
          responseType: 'blob',
        })
        .then((response) => {
          if (response.data.error) {
            return handlerError(response.data.error);
          }
          return response;
        })
        .catch(handlerError);
    },

    async getClients({ commit }) {
      axiosInstance
        .get(urlsAPI.clientsURL)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('updateClients', response.data);
          }
        })
        .catch(handlerError);
    },

    async createClient({ commit }, body) {
      return axiosInstance
        .post(urlsAPI.clientsURL, body)
        .then((response) => {
          if (response.data.error) {
            return handlerError(response.data.error);
          }
          commit('addClient', response.data);
          return response.data;
        })
        .catch(handlerError);
    },

    async updateClient({ commit }, { id, body }) {
      axiosInstance
        .put(urlsAPI.clientsURL + id, body)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('putClient', response.data);
          }
        })
        .catch(handlerError);
    },

    async delete({ commit }, id) {
      axiosInstance
        .delete(urlsAPI.clientsURL + id)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('deleteAction', id);
          }
        })
        .catch(handlerError);
    },

    async search({ commit }, name) {
      axiosInstance
        .get(urlsAPI.clientsSearchURL, {
          params: {
            name,
          },
        })
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('updateClients', response.data);
          }
        })
        .catch(handlerError);
    },

    async getClientOfTask({ commit }, id) {
      axiosInstance
        .get(urlsAPI.clientsURL + id)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('updateClients', [response.data]);
          }
        })
        .catch(handlerError);
    },

    async getCurrentChecks({ commit }) {
      axiosInstance
        .get(urlsAPI.clientsCurrentChecksURL)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('updateChecks', response.data);
          }
        })
        .catch(handlerError);
    },

    async getCurrentRevisions({ commit }) {
      return axiosInstance
        .get(urlsAPI.clientsCurrentRevisionsURL)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('updateRevisions', response.data);
          }
        })
        .catch(handlerError);
    },

    async downloadDocuments(body, { start, end }) {
      busEvent.$emit('succesPopupCreated', 'Documentul se proceseaza... Poate dura cateva secunde');

      try {
        const response = await axiosInstance.get(urlsAPI.clientsExportDocumentsURL, {
          params: {
            start,
            end,
          },
          responseType: 'blob',
          timeout: 1800000, // 30min = 1000*60*30
        });
        if (response.data.error) {
          return handlerError(response.data.error);
        }

        return response;
      } catch (e) {
        return handlerError(e);
      }
    },
  },
};
